// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"193bb29e","453":"8ab44547","493":"ffe97471","562":"49c61819","928":"9b615555","948":"e0949044"}[chunkId] + ".chunk.js";
};